var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-detail" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("Whatsapp V3 Channel Details"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("Whatsapp V3 Kanalınızı yönetin"))),
        ]),
      ]),
      _vm._v(" "),
      _vm.shouldShowIframe
        ? [
            _c(
              "div",
              { staticClass: "onboarding-wrapper" },
              [
                _c(
                  "SupsisButton",
                  {
                    staticClass: "integration-button",
                    attrs: { type: "primary", large: "", primary: "" },
                    on: { click: _vm.openOnboardingLink },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Whatsapp V3 Entegrasyonu Yap")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "integration-button",
                    attrs: { xlarge: "", ghost: "", icon: "help" },
                    on: { click: _vm.connectSupportTeamRequest },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Yardım Al")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("a-alert", {
                  staticClass: "mt-4",
                  attrs: {
                    message: "Bilgilendirme",
                    description:
                      "Eğer Whatsapp V3 hesabınızı başarılı bir şekilde tanımladıysanız, bu ekranın güncellenmesi biraz zaman alabilir.",
                    type: "info",
                    "show-icon": "",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm.shouldShowReconnect
        ? [
            _c(
              "div",
              { staticClass: "onboarding-wrapper" },
              [
                _c(
                  "SupsisButton",
                  {
                    staticClass: "integration-button",
                    attrs: { type: "primary", large: "", primary: "" },
                    on: {
                      click: function ($event) {
                        return _vm.openOnboardingLink("reconnect")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Whatsapp V3 Tekrar Bağla")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "integration-button",
                    attrs: { xlarge: "", ghost: "", icon: "help" },
                    on: { click: _vm.connectSupportTeamRequest },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Yardım Al")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("a-alert", {
                  staticClass: "mt-4",
                  attrs: {
                    message: "Bilgilendirme",
                    description:
                      "Eğer Whatsapp V3 hesabınızı başarılı bir şekilde tanımladıysanız, bu ekranın güncellenmesi biraz zaman alabilir.",
                    type: "info",
                    "show-icon": "",
                  },
                }),
              ],
              1
            ),
          ]
        : [
            _c("a-form", [
              _c("div", { staticClass: "form-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "input-wrapper" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.channelName"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("a-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "whatsapp_business_api.channelName"
                        ),
                        name: "channelName",
                      },
                      model: {
                        value: _vm.clone.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "name", $$v)
                        },
                        expression: "clone.name",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("ChannelForwardSetting", {
              attrs: { channel: _vm.clone, groupChatbotView: true },
              on: {
                input: function (c) {
                  return (_vm.clone = c)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form-footer" }, [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "pr-confirm-btn",
                      attrs: { type: "primary", disabled: _vm.loading },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.update")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ],
      _vm._v(" "),
      _vm.showIframe
        ? _c("div", { staticClass: "iframe-overlay" }, [
            _c("div", { staticClass: "iframe-container" }, [
              _c(
                "div",
                { staticClass: "iframe-header" },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("Whatsapp V3 Entegrasyonu"))),
                  ]),
                  _vm._v(" "),
                  _c("a-button", {
                    staticClass: "close-button",
                    attrs: { icon: "close" },
                    on: { click: _vm.closeIframe },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("iframe", { attrs: { src: _vm.iframeUrl, frameborder: "0" } }),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }